import { render, staticRenderFns } from "./aiCore.vue?vue&type=template&id=6ed7a827&scoped=true"
import script from "./aiCore.vue?vue&type=script&lang=js"
export * from "./aiCore.vue?vue&type=script&lang=js"
import style0 from "./aiCore.vue?vue&type=style&index=0&id=6ed7a827&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed7a827",
  null
  
)

export default component.exports